const system_limit = {
    limit_exceeded: 'Você atingiu o limite do sistema. Entre em contato com o suporte para obter ajuda.',
};
export default Object.freeze(system_limit);
